import { render, staticRenderFns } from "./SalesReportSummaryTotal.vue?vue&type=template&id=b753d68e&"
import script from "./SalesReportSummaryTotal.vue?vue&type=script&lang=ts&"
export * from "./SalesReportSummaryTotal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports